<template>
  <el-dialog
    :title="title"
    :visible.sync="brand_dialogVisible"
    width="70%"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="addressWrap">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px">
        <el-form-item prop="brandName" label="品牌名称">
          <el-input v-model="form.brandName" placeholder="请填写品牌名称" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item prop="trademarkNumber" label="主商标号">
          <el-input v-model="form.trademarkNumber" placeholder="请填写主商标号" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item prop="revenue" label="产值(万元)">
          <el-input-number v-model="form.revenue" :controls="false" style="width:100%" :min="0" :max="9999999"></el-input-number>
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align:center;" class="mt30">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { brandSave, brandUpdate, brandView } from "@/api/index";
export default {
  props: {
    brand_dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      title: "新增",
      form: {
        brandName: "",
        trademarkNumber: "",
        revenue: 0
      },
      rules: {
        brandName: [
          { required: true, message: "请输入品牌名称", trigger: "blur" }
        ],
        trademarkNumber: [
          { required: true, message: "请输入主商标号", trigger: "blur" }
        ],
        revenue: [
          { required: true, validator:this.$reg.realnumber, trigger: "产值" }
        ]
      }
    };
  },
  mounted() {
    if (this.id) {
      this.title = "修改";
      brandView(this.id).then(res => {
        this.form = res.data;
      });
    }
  },
  methods: {
    handleClose() {
      this.$emit("update:brand_dialogVisible", false);
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.id) {
            //修改
            brandUpdate({
              ...this.form
            }).then(res => {
              if (res.status == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
                this.$emit("update:brand_dialogVisible");
                this.$emit("refresh");
              }
            });
          } else {
            //新增
            brandSave({
              ...this.form
            }).then(res => {
              if (res.status == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success"
                });
                this.$emit("update:brand_dialogVisible");
                this.$emit("refresh");
              }
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
</style>